import { atom } from "jotai";

import { DiningBookingWizardDataAtom } from "../../stores";

export const getDiningPartySize = atom((get) => {
  const diningData = get(DiningBookingWizardDataAtom);
  return diningData?.partySize ?? 0;
});
